import { render } from "./youtobe.vue?vue&type=template&id=2a711941&scoped=true"
import script from "./youtobe.vue?vue&type=script&lang=js"
export * from "./youtobe.vue?vue&type=script&lang=js"

import "./youtobe.vue?vue&type=style&index=0&id=2a711941&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a711941"]])

export default __exports__